import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import {
  AfterViewChecked,
  OnDestroy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import {
  PageHeaderService,
  PageHeaderState,
} from '../../services/page-header/page-header.service';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  standalone: false,
})
export class PageHeaderComponent implements AfterViewChecked, OnDestroy {
  @ViewChild('actionsHost') actionsHost?: ElementRef<HTMLElement>;

  /** Number of actions rendered by the projected template. */
  actionCount = 0;
  compact = false;
  private breakpointSubscription: Subscription;

  constructor(
    public pageHeader: PageHeaderService,
    private cdr: ChangeDetectorRef,
    breakpoints: BreakpointObserver
  ) {
    this.breakpointSubscription = breakpoints
      .observe('(max-width: 767px)')
      .subscribe((result) => {
        this.compact = result.matches;
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.breakpointSubscription.unsubscribe();
  }

  ngAfterViewChecked(): void {
    // Keep a single action inline; only multiple actions need a compact menu.
    const host = this.actionsHost?.nativeElement;
    const count = host?.querySelectorAll('button, a, .btn').length || 0;
    if (count !== this.actionCount) {
      this.actionCount = count;
      this.cdr.detectChanges();
    }
  }

  hasCounter(state: PageHeaderState): boolean {
    return state.count !== null && state.count !== undefined;
  }

  onBack(state: PageHeaderState): void {
    this.pageHeader.goBack(state);
  }
}
